import React, {Component, Suspense} from 'react';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../index.less';
import api from './api';
import { userContext } from './providers/userContext';
import { ToastProvider } from './providers/toast';

import bg from '../img/bg.png';

import Loader from './components/UI/Loader';
import Header from './components/Header';
import AppContainer from './components/AppContainer';
import { NavProjectProvider } from './providers/navProject';
import SpinnerComponent from "./components/SpinnerComponent/SpinnerComponent";
import LoadingFallback from "./components/LoadingFallback";

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      user: null,
    };
  }

  async componentDidMount() {
    const authenticated = await keycloak.init({ onLoad: 'check-sso', checkLoginIframeInterval: 1 });

    if (keycloak.authenticated) {
      sessionStorage.setItem('kctoken', keycloak.token);
      v(keycloak.token, {
        serviceName: 'priority2030',
      });
      const user = await keycloak.loadUserInfo();
      const userCtx = await api.get('/auth/getCx');
      // todo: прикрутить redux и либо добить, либо отказаться от ReactKeycloakProvider
      this.setState({
        authenticated,
        user: userCtx,
      });

      setInterval(() => {
        keycloak.updateToken(60).then((refreshed) => {
          if (refreshed) {
            console.log('Token was successfully refreshed');
          } else {
            console.log('Token is still valid');
          }
        }).catch(() => {
          console.log('Failed to refresh the token, or the session has expired');
        });
        sessionStorage.setItem('kctoken', keycloak.token);
      }, 10000);
    } else {
      keycloak.login();
    }
  }

  // eventLogger = (event, error) => {
  //     console.log('onKeycloakEvent', event, error);
  // }
  //
  // tokenLogger = (tokens) => {
  //     console.log('onKeycloakTokens', tokens); //если надо глянуть токены - раскомментировать
  // }

  render() {
    const { keycloak, authenticated, user } = this.state;
    const content = authenticated
      ? (
        <div style={styledBG}>
          <Header />
          <AppContainer userCtx={user} />
          {/* <NavBar userCtx={this.state.user} /> */}
          {/* <p>This is a Keycloak-secured component of your application. You shouldn't be able */}
          {/*    to see this unless you've authenticated with Keycloak.<br /> */}
          {/*    /сюда поместить основной компонент с контентом/</p> */}
          {/* {user && <p>User Info: {user.person[0].UserPrincipalName}</p>} */}
        </div>
      )
      : (<Loader />);
    return (
      <userContext.Provider value={this.state.user}>
        <NavProjectProvider>
          <ToastProvider>
            <main style={{ height: '100vh' }}>
              {content}
            </main>
          </ToastProvider>
        </NavProjectProvider>
      </userContext.Provider>
    );
  }
}

const styledBG = {
  backgroundImage: `url(${bg})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right top',
};

/**
 * This sends activity info to user profile.
 * @function
 * @param {string} token - users keycloak token
 * @param {object} info - description (serviceName required)
 * {
 *  serviceName:'service',
 *  serviceSection:'section',
 *  actionMessage: 'user enters page',
 *  orgInn: 'organization inn',
 *  orgTitle: 'organization title',
 *  orgPost: 'organization post'
 * }
 */
function v(token, info) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://lk-profile-api.my1.urfu.ru/activity');
  xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(JSON.stringify(info));
}
